export default function InstantGuide() {
  const steps = [
    {
      number: '1',
      title: 'オンラインで申し込み',
      description: '公式サイトから必要事項を入力して申し込み。スマホから5分程度で完了します。'
    },
    {
      number: '2',
      title: '最短10秒で審査完了',
      description: 'AIによる自動審査で、最短10秒で審査結果が通知されます。'
    },
    {
      number: '3',
      title: 'カード番号即時発行',
      description: '審査通過後、すぐにカード番号が発行され、アプリで確認できます。'
    },
    {
      number: '4',
      title: 'すぐに利用開始',
      description: 'ネットショッピングやスマホ決済（Apple Pay/Google Pay）ですぐに使えます。'
    }
  ];

  const notes = [
    {
      icon: 'ri-time-line',
      title: '即日発行の条件',
      description: '9:00〜19:30の間に申し込み、必要書類を揃えておくとスムーズです。'
    },
    {
      icon: 'ri-smartphone-line',
      title: 'スマホ決済ですぐ使える',
      description: 'Apple PayやGoogle Payに登録すれば、プラスチックカードが届く前から店舗でも使えます。'
    },
    {
      icon: 'ri-mail-line',
      title: 'プラスチックカードは後日郵送',
      description: 'カード番号は即日発行されますが、プラスチックカードは1週間程度で郵送されます。'
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4">
        {/* Steps */}
        <div className="mb-16">
          <h3 className="text-3xl font-bold text-center mb-4 text-[#003366]">
            即日発行の流れ
          </h3>
          <p className="text-center text-gray-600 mb-12 max-w-2xl mx-auto">
            申し込みから利用開始までわずか数分。今すぐクレジットカードが必要な方でも安心です。
          </p>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all h-full">
                  <div className="w-12 h-12 bg-gradient-to-br from-[#FF6B6B] to-[#EE5A6F] rounded-full flex items-center justify-center mb-4">
                    <span className="text-white text-xl font-bold">{step.number}</span>
                  </div>
                  <h4 className="text-lg font-bold mb-3 text-[#003366]">{step.title}</h4>
                  <p className="text-sm text-gray-700 leading-relaxed">{step.description}</p>
                </div>
                {index < steps.length - 1 && (
                  <div className="hidden md:block absolute top-1/2 -right-3 transform -translate-y-1/2 z-10">
                    <i className="ri-arrow-right-line text-2xl text-[#FF6B6B] w-6 h-6 flex items-center justify-center"></i>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Notes */}
        <div>
          <h3 className="text-3xl font-bold text-center mb-12 text-[#003366]">
            即日発行の注意点
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {notes.map((note, index) => (
              <div
                key={index}
                className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all"
              >
                <div className="w-14 h-14 bg-gradient-to-br from-[#FF6B6B] to-[#EE5A6F] rounded-full flex items-center justify-center mb-4">
                  <i className={`${note.icon} text-white text-2xl w-8 h-8 flex items-center justify-center`}></i>
                </div>
                <h4 className="text-xl font-bold mb-3 text-[#003366]">{note.title}</h4>
                <p className="text-gray-700 leading-relaxed">{note.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="mt-12 text-center">
          <a
            href="#ranking"
            className="inline-block bg-[#FF6B6B] text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-[#EE5A6F] transition-all cursor-pointer whitespace-nowrap shadow-lg"
          >
            即日発行カードを今すぐチェック
          </a>
        </div>
      </div>
    </section>
  );
}
